exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-cards {\n  width: 100%;\n  margin: 60px 0; }\n  .c-cards__container {\n    max-width: 1170px;\n    margin: 0 auto; }\n  .c-cards__list {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/stylesheets/components/cardslist.scss
// module id = 121
// module chunks = 0